<template>
  <div class="column content-box">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="add-circle"
      @click="openAddPopup"
    >
      {{ $t('INTEGRATION_SETTINGS.SYONET.HEADER_BTN_TXT') }}
    </woot-button>

    <div class="row">
      <div class="small-8 columns with-right-space">
        <div v-if="publicIps.length" class="syonet-connections__ips-list">
          <p>
            <strong>IPs para liberação de acesso</strong>
          </p>
          <p>
            Libere os IPs abaixo para que a aplicação consiga utilizar
            as conexões cadastradas.
          </p>
          <ul>
            <li v-for="ip in publicIps" :key="ip">
              {{ ip }}
            </li>
          </ul>
        </div>

        <div
          v-if="!uiFlags.isFetching && !records.length"
          class="syonet-connections__empty-state"
        >
          <p class="no-items-error-message">
            {{ $t('INTEGRATION_SETTINGS.SYONET.LIST.404') }}
          </p>
        </div>

        <woot-loading-state
          v-if="uiFlags.isFetching"
          :message="$t('INTEGRATION_SETTINGS.SYONET.LOADING')"
        />

        <table
          v-if="!uiFlags.isFetching && records.length"
          class="woot-table"
        >
          <thead>
            <th
              v-for="thHeader in $t('INTEGRATION_SETTINGS.SYONET.LIST.TABLE_HEADER')"
              :key="thHeader"
            >
              {{ thHeader }}
            </th>
          </thead>
          <tbody>
            <syonet-connection-row
              v-for="syonetConnection in records"
              :key="syonetConnection.id"
              :syonet-connection="syonetConnection"
              @edit="openEditPopup"
              @delete="openDeletePopup"
            />
          </tbody>
        </table>
      </div>

      <div class="small-4 columns">
        <span v-dompurify-html="$t('INTEGRATION_SETTINGS.SYONET.SIDEBAR_TXT')" />
      </div>
    </div>

    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <new-syonet-connection v-if="showAddPopup" :on-close="hideAddPopup" />
    </woot-modal>

    <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-syonet-connection
        v-if="showEditPopup"
        :id="selectedSyonetConnection.id"
        :value="selectedSyonetConnection"
        :on-close="hideEditPopup"
      />
    </woot-modal>

    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('INTEGRATION_SETTINGS.SYONET.DELETE.CONFIRM.TITLE')"
      :message="deleteMessage"
      :confirm-text="$t('INTEGRATION_SETTINGS.SYONET.DELETE.CONFIRM.YES')"
      :reject-text="$t('INTEGRATION_SETTINGS.SYONET.DELETE.CONFIRM.NO')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import NewSyonetConnection from './NewSyonetConnection';
import EditSyonetConnection from './EditSyonetConnection';
import SyonetConnectionRow from './SyonetConnectionRow';

const {
    LIST_IPS_PUBLIC: listIpsPublic, // Exemplo: '172.0.0.1,172.0.0.2'
} = window.globalConfig

export default {
  components: {
    NewSyonetConnection,
    EditSyonetConnection,
    SyonetConnectionRow,
  },
  mixins: [alertMixin],
  data() {
    return {
      showAddPopup: false,
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedSyonetConnection: {},
    };
  },
  computed: {
    ...mapGetters({
      records: 'syonetConnections/getSyonetConnections',
      uiFlags: 'syonetConnections/getUIFlags',
    }),
    publicIps() {
      return (listIpsPublic || '')
        .split(',')
        .map(ip => ip.trim())
        .filter(Boolean);
    },
    deleteMessage() {
      return ` ${this.selectedSyonetConnection.name}?`;
    },
  },
  mounted() {
    this.$store.dispatch('syonetConnections/get');
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    openEditPopup(syonetConnection) {
      this.selectedSyonetConnection = syonetConnection;
      this.showEditPopup = true;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    openDeletePopup(syonetConnection) {
      this.selectedSyonetConnection = syonetConnection;
      this.showDeleteConfirmationPopup = true;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    confirmDeletion() {
      this.closeDeletePopup();
      this.deleteSyonetConnection(this.selectedSyonetConnection.id);
    },
    async deleteSyonetConnection(id) {
      try {
        await this.$store.dispatch('syonetConnections/delete', id);
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.SYONET.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('INTEGRATION_SETTINGS.SYONET.DELETE.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  },
};
</script>
